import { type ComponentProps, type PropsWithChildren } from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

import { Container } from '@/components/Container';

interface Props extends PropsWithChildren {
  reverse?: boolean;
  title?: string;
  className?: string;
}

function CampaignSegment({ children, reverse = false, className }: Props) {
  return (
    <Container>
      <div
        className={clsx(
          styles.segment,
          { [styles.reverse]: reverse },
          className
        )}
      >
        {children}
      </div>
    </Container>
  );
}

function Title({
  children,
  className,
  ...rest
}: ComponentProps<typeof Heading>) {
  return (
    <Heading
      variant="xl"
      as="h2"
      className={clsx(styles.title, className)}
      {...rest}
    >
      {children}
    </Heading>
  );
}

function Image({ children, className, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={clsx(styles.image, className)} {...rest}>
      {children}
    </div>
  );
}

function Content({ children, className, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={clsx(styles.content, className)} {...rest}>
      {children}
    </div>
  );
}

CampaignSegment.Title = Title;
CampaignSegment.Image = Image;
CampaignSegment.Content = Content;

export { CampaignSegment };
